import { DateTime } from 'luxon'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { IField } from '@/types/tasksApprovals'
import { formatDate } from '@/utils/date'

const DateInterval = ({ item }: { item: IField }) => {
    const dates = (item.value as string).split(' - ')
    const formatedDate = `${formatDate(dates[0], DateTime.DATE_SHORT)} - ${formatDate(dates[1], DateTime.DATE_SHORT)}`
    return (
        <Box py="8px" px="24px">
            <Text fontSize={12} pb="4px">
                {item.name}
            </Text>
            <Text fontSize={14} fontWeight="bold">
                {formatedDate}
            </Text>
        </Box>
    )
}

export default DateInterval
